var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/** Thin horizontal divider. Props mirror `SimpleButton`'s
 *  `variant` / `size` / `special` / `dashed` shape so usage stays
 *  consistent across the component library. */
let BasicSeparator = class BasicSeparator extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.variant = 'secondary';
        this.special = false;
        this.dashed = false;
    }
    render() {
        const classes = [
            'ggo-separator',
            `ggo-separator--${this.size}`,
            `ggo-separator--${this.variant}`,
            this.special ? 'ggo-separator--special' : '',
            this.dashed ? 'ggo-separator--dashed' : '',
        ]
            .filter(Boolean)
            .join(' ');
        return html `<hr class=${classes} role="separator" />`;
    }
};
BasicSeparator.styles = css `
    :host {
      display: block;
    }

    .ggo-separator {
      width: 100%;
      border: 0;
      border-top-style: solid;
      border-top-width: 1px;
    }

    /* Sizes — vertical breathing room around the line */
    .ggo-separator--small {
      margin: 8px 0;
    }
    .ggo-separator--medium {
      margin: 16px 0;
    }
    .ggo-separator--large {
      margin: 28px 0;
    }

    /* Variants — line colour */
    .ggo-separator--primary {
      border-top-color: #0078d4;
    }
    .ggo-separator--secondary {
      border-top-color: #c8d3e0;
    }
    .ggo-separator--success {
      border-top-color: #28a745;
    }
    .ggo-separator--danger {
      border-top-color: #dc3545;
    }
    .ggo-separator--warning {
      border-top-color: #ffc107;
    }

    /* Special — heavier accent line */
    .ggo-separator--special {
      border-top-width: 2px;
    }

    /* Dashed */
    .ggo-separator--dashed {
      border-top-style: dashed;
    }
  `;
__decorate([
    property({ type: String })
], BasicSeparator.prototype, "size", void 0);
__decorate([
    property({ type: String })
], BasicSeparator.prototype, "variant", void 0);
__decorate([
    property({ type: Boolean })
], BasicSeparator.prototype, "special", void 0);
__decorate([
    property({ type: Boolean })
], BasicSeparator.prototype, "dashed", void 0);
BasicSeparator = __decorate([
    customElement('basic-separator')
], BasicSeparator);
export { BasicSeparator };
//# sourceMappingURL=BasicSeparator.js.map